import { Skeleton } from '@/components/ui/skeleton'

/** Approximates the CMS-driven contact form while its chunk loads. */
export const ContactFormSkeleton = () => {
  return (
    <div className="px-2 py-6 xl:p-8" aria-busy="true">
      <div className="grid grid-cols-1 gap-6">
        <Skeleton className="h-8 w-48" />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <Skeleton className="h-12 w-full rounded-xl" />
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>
        <Skeleton className="h-12 w-full rounded-xl" />
        <Skeleton className="h-40 w-full rounded-xl" />
        <Skeleton className="h-12 w-full max-w-40 rounded-xl" />
      </div>
    </div>
  )
}
